<div class="image-highlight" *ngIf="config">
    <div class="chart">
        <img [src]="config.metadata['url']" />
    </div>
</div>